import { Box, ButtonPrimary, DataCard, BoxedRow, skinVars, Text3, Text2 } from '@telefonica/mistica';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../utils/navigation/navigateParams';
import './index.scss';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import { useState, useEffect } from 'react';

export interface NeedMoreGigsData {
    productId: any;
}

export const NeedMoreGigs: React.FC<NeedMoreGigsData> = ({ productId }: NeedMoreGigsData) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const sendToNative = () => {
        const storage = localStorage.getItem('storage') || '';
        const storageJson = JSON.parse(storage);
        const type = 'modeModal-backgroundBlue';
        const url = '/mobile/bonus-available';
        const title = 'Bonos disponibles';
        const queryParams = { productId: productId };
        if (navigateParams(type, url, queryParams, storageJson, title)) {
            navigate(url + '?productId=' + productId);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className='NeedMoreGigs'>
            {windowWidth < 1024 ? (
                <BoxedRow
                    right={
                        <ButtonPrimary
                            small
                            onPress={() => {
                                sendToNative();
                            }}
                        >
                            {t('moreGigsButton')}
                        </ButtonPrimary>
                    }
                    extra={
                        <div className='card_text'>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {t('moreGigsTitle')}
                            </Text3>
                            <Text2 regular color={skinVars.colors.textSecondary}>
                                {t('moreGigsDescription')}
                            </Text2>
                        </div>
                    }
                    title=''
                ></BoxedRow>
            ) : (
                <Box>
                    <DataCard
                        title={t('moreGigsTitle')}
                        description={t('moreGigsDescription')}
                        button={
                            <ButtonPrimary
                                small
                                onPress={() => {
                                    sendToNative();
                                }}
                            >
                                {t('moreGigsButton')}
                            </ButtonPrimary>
                        }
                    ></DataCard>
                </Box>
            )}
        </div>
    );
};

export default NeedMoreGigs;
